// extracted by mini-css-extract-plugin
export default {"pd_detail_top_img":"productDetailPage_pd_detail_top_img__VYCWs"};